// Shared visual mapping for a ValidationStatus — used by the Reality Check card
// header and the strategy-card status chip so they never drift.

import type { ValidationStatus } from '../../types/validation';

export interface StatusVisual {
  chip: string;     // short chip label
  full: string;     // longer headline label
  classes: string;  // tailwind bg/text/border for the chip
  dot: string;      // tailwind bg for the status dot
}

export function statusVisual(s: ValidationStatus): StatusVisual {
  switch (s) {
    case 'solid':
      // Scoped, not an over-claim: only the COST dimension has been checked.
      return { chip: 'Survives costs', full: 'Cost check passed', classes: 'bg-emerald-100 text-emerald-800 border-emerald-200', dot: 'bg-emerald-500' };
    case 'cost_fragile':
      return { chip: 'Cost-fragile', full: 'Barely survives costs', classes: 'bg-amber-100 text-amber-800 border-amber-200', dot: 'bg-amber-500' };
    case 'cost_failed':
      return { chip: "Don't deploy", full: "Don't deploy this yet", classes: 'bg-red-100 text-red-800 border-red-200', dot: 'bg-red-500' };
    case 'insufficient':
      return { chip: 'Too few trades', full: 'Too few trades to judge', classes: 'bg-gray-100 text-gray-700 border-gray-200', dot: 'bg-gray-400' };
    case 'untested':
    default:
      return { chip: 'Untested', full: 'Not yet tested', classes: 'bg-gray-100 text-gray-600 border-gray-200', dot: 'bg-gray-300' };
  }
}
